<template>
  <div>
    <div v-if="SuchbegriffGross">
      <span v-if="this.$store.getters.fetchSuchbegriff">
        <h1 :class="this.ÜberschriftSize">
          <span class="font-weight-bold">{{ SuchbegriffGross }}</span>
        </h1>
        <h2 :class="this.ÜberschriftSize" class="mt-2">  
          {{ Ort }} 
        </h2>
      </span>
    </div>

    <v-layout row wrap class="mt-4">
      <v-flex xs12>
        <h2 class="headline" id="landinghead">
          <strong>{{ this.$store.getters.fetchBetriebe.betriebe.length }}</strong>
          Innungsbetriebe gefunden {{ OrtText }} {{ Radius }}
        </h2>
      </v-flex>
      <span v-if="this.$store.getters.fetchSuchbegriff">
      <v-flex xs12 v-if="this.$store.getters.fetchSuchbegriff.gewerk.defaultleistung_id != this.$store.getters.fetchSuchbegriff.id">
        <v-btn @click="vuexBetriebe()" :loading="busy" class="accent mt-3" large>
          Ausweiten auf Gewerk {{ this.Gewerk }}
        </v-btn>
      </v-flex>
      </span>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  metaInfo () {
    return { title: this.SuchbegriffGross + ' in ' + this.Ort }
  },
  components: {},
  data: () => ({
    busy: false
  }),
  computed: {
    ...mapGetters({
      fetchBetriebe: 'fetchBetriebe'
    }),
    StadtNameGross: function () {
      return this.$store.state.suche.stadt
    },
    PLZ: function () {
      return ' in PLZ ' + this.$store.state.suche.plz
    },
    PLZZusatz: function () {
      if (this.$store.state.suche.radius) {
        return ' und Umgebung'
      } else return ''
    },
    Ort: function () {
      if (this.$store.getters.fetchStandort.name.name) {
        return 'in ' + this.$store.getters.fetchStandort.name.name
      } else if (this.$store.state.suche.kh) {
        return this.$store.state.suche.kh.name
      } else if (this.$store.state.suche.plz) {
        return 'in ' + this.$store.state.suche.plz + this.PLZZusatz
      }
    },
    OrtText: function () {
      // if (this.$store.state.suche.stadt) {
      //   return 'in und in der Nähe von ' + this.$store.state.suche.stadt
      // } else if (this.$store.state.suche.plz) {
      //   return 'im PLZ-Gebiet ' + this.$store.state.suche.plz
      // }
      if (this.$store.getters.fetchStandort.name) {
        return 'in und in der Nähe von ' + this.$store.getters.fetchStandort.name.name
      } else if (this.$store.state.suche.plz) {
        return 'im PLZ-Gebiet ' + this.$store.state.suche.plz
      }
    },
    Radius: function () {
      // if (this.$store.state.suche.radius && !this.$store.state.suche.plz) {

      if (this.$store.state.suche.radius) {
        return '(' + this.$store.state.suche.radius.toFixed(1) + ' km)'
      } else return ''
     // } else return '(' + this.$store.state.suche.radius + ' km)'
    },
    Radiusalt: function () {
      if (this.$store.state.suche.standortwert[0].name.radius) {
        if (this.$store.state.suche.leistung[0].faktor) {
          return '(' + this.$store.state.suche.leistung[0].faktor * this.$store.state.suche.standortwert[0].name.radius + ' km)'
        }
      }
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      }
      if (this.$vuetify.breakpoint.name === 'sm') {
        return 'display-1'
      } else {
        return 'display-2'
      }
    },
    SuchbegriffGross: function () {
      if (this.$store.state.suche.suchbegriffmanuell) {
        return this.$store.state.suche.suchbegriffmanuell
      }
      if (
        typeof this.$store.getters.fetchBetriebe.suchbegriff.leistung ===
        'object'
      ) {
        return (
          'Thema: ' + this.$store.getters.fetchBetriebe.suchbegriff.suchbegriff
        )
      }

      if (this.$store.getters.fetchBetriebe.suchbegriff.leistung) {
        return this.$store.getters.fetchBetriebe.suchbegriff.leistung
      } else {
        return ''
      }
      // return this.$store.getters.fetchBetriebe.suchbegriffmanuell
    },
    Gewerk: function () {
      if (
        typeof this.$store.getters.fetchBetriebe.suchbegriff.gewerk === 'object'
      ) {
        return this.$store.getters.fetchBetriebe.suchbegriff.gewerk.name
      }
    }
  },
  mounted: function () {},

  methods: {
    async vuexBetriebe () {
      // busy löppt nicht im Moment
      this.busy = true
      var payload = {
        leistung: this.$store.getters.fetchBetriebe.suchbegriff.gewerk.defaultleistung_id,
        standort: this.$store.state.suche.stadt,
        postleitzahl: this.$store.state.suche.plz,
        plzsuche: this.plzsuche
        // standort: this.$store.state.landing.HeimatStadt
        // suchbegriff: suchbegriff.text
      }
      await this.$store.dispatch('fetchBetriebe', payload).then(() => {
        if (!this.$store.getters.fetchBetriebe.error) {
          // this.$router.push({
          //   name: 'treffer'
          // })
        } else {
          this.busy = false
        }
      })
      this.busy = false
      this.$emit('busy', false)
    }
  }
}
</script>
<style></style>
